import { useState, useEffect } from "react";
import "./index.scss";

/**
 * CSS dosyalarının yüklenmesini bekleyen component
 * CSS'ler yüklenene kadar loading ekranı gösterir
 */
const StylesheetLoader = ({ stylesheets, children }) => {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        if (stylesheets.length === 0) {
            setIsLoaded(true);
            return;
        }

        let mounted = true;

        const checkStylesheetLoaded = (link) => {
            return new Promise((resolve) => {
                // Eğer stylesheet zaten yüklenmişse hemen resolve et
                if (link.sheet || link.styleSheet) {
                    resolve();
                    return;
                }

                // onload event'i ile kontrol et
                const onLoad = () => {
                    link.removeEventListener('load', onLoad);
                    link.removeEventListener('error', onError);
                    resolve();
                };

                const onError = () => {
                    link.removeEventListener('load', onLoad);
                    link.removeEventListener('error', onError);
                    resolve(); // Hata olsa bile devam et
                };

                link.addEventListener('load', onLoad);
                link.addEventListener('error', onError);

                // Timeout ekle (maksimum 2 saniye bekle)
                setTimeout(() => {
                    link.removeEventListener('load', onLoad);
                    link.removeEventListener('error', onError);
                    resolve();
                }, 2000);
            });
        };

        const loadStylesheets = async () => {
            // Önce tüm CSS'lerin zaten yüklü olup olmadığını kontrol et
            const allLoaded = stylesheets.every((href) => {
                const link = document.querySelector(`link[href="${href}"]`);
                return link && (link.sheet || link.styleSheet);
            });

            if (allLoaded && mounted) {
                // Tüm CSS'ler zaten yüklüyse hemen göster
                setIsLoaded(true);
                return;
            }

            // CSS'leri yükle veya yüklenmesini bekle
            const promises = stylesheets.map(async (href) => {
                const existingLink = document.querySelector(`link[href="${href}"]`);
                if (existingLink) {
                    await checkStylesheetLoaded(existingLink);
                    return;
                }

                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.href = href;
                document.head.appendChild(link);

                await checkStylesheetLoaded(link);
            });

            await Promise.all(promises);

            if (mounted) {
                // Kısa bir gecikme ekle (render için)
                setTimeout(() => {
                    if (mounted) {
                        setIsLoaded(true);
                    }
                }, 50);
            }
        };

        loadStylesheets();

        return () => {
            mounted = false;
        };
    }, [stylesheets.join(',')]);

    if (!isLoaded) {
        return (
            <div className="stylesheet-loader">
                <div className="stylesheet-loader__content">
                    <img 
                        src="https://www.yosdanismanim.com/wp-content/uploads/2025/11/yos-logo.png" 
                        alt="YÖS Portal" 
                        className="stylesheet-loader__logo"
                    />
                    <div className="stylesheet-loader__spinner">
                        <div className="stylesheet-loader__spinner-ring"></div>
                        <div className="stylesheet-loader__spinner-ring stylesheet-loader__spinner-ring--secondary"></div>
                    </div>
                    <div className="stylesheet-loader__text">
                        Yükleniyor
                        <span className="stylesheet-loader__dots">
                            <span></span>
                            <span></span>
                            <span></span>
                        </span>
                    </div>
                </div>
            </div>
        );
    }

    return children;
};

export default StylesheetLoader;

